export const RECENT_LIMIT = 3;

export interface RecentCandidate {
  kind: 'chat' | 'meeting';
  id: string;
  title: string;
  date: Date;
  summary?: string;
}

interface RecentChatSource {
  id: string;
  title: string;
  updatedAt: Date;
  reportTemplateId: number | null;
}

interface RecentMeetingSource {
  id: string;
  name: string | null;
  summary: string | null;
  lastTranscribedAt: Date | null;
  createdAt: Date;
}

export function collectRecentCandidates(
  chats: Iterable<RecentChatSource>,
  meetings: Iterable<RecentMeetingSource>
): RecentCandidate[] {
  const candidates: RecentCandidate[] = [];
  let chatCount = 0;
  for (const chat of chats) {
    if (chat.reportTemplateId !== null) continue;
    candidates.push({
      kind: 'chat',
      id: chat.id,
      title: chat.title,
      date: chat.updatedAt,
    });
    chatCount += 1;
    if (chatCount > RECENT_LIMIT) break;
  }
  let meetingCount = 0;
  for (const meeting of meetings) {
    candidates.push({
      kind: 'meeting',
      id: meeting.id,
      title: meeting.name ?? 'Untitled',
      date: meeting.lastTranscribedAt ?? meeting.createdAt,
      summary: meeting.summary ?? '',
    });
    meetingCount += 1;
    if (meetingCount >= RECENT_LIMIT) break;
  }
  return candidates;
}

export function selectRecentItems(
  candidates: RecentCandidate[],
  openThreadId: string | undefined,
  limit = RECENT_LIMIT
): RecentCandidate[] {
  return candidates
    .filter((item) => !(item.kind === 'chat' && item.id === openThreadId))
    .sort((a, b) => b.date.getTime() - a.date.getTime())
    .slice(0, limit);
}
